import React from "react";
import herobg from "../../Assets/herobg.png";

const HeroSection = () => {
  return (
    <div className="min-h-screen flex flex-col lg:flex-row items-center justify-center bg-gradient-to-r from-blue-50 to-indigo-50 px-4 sm:px-6 lg:px-8 py-12">
      {/* Left Section - Image */}
      <div className="lg:w-1/2 flex justify-center mb-8 lg:mb-0">
        <img
          src={herobg}
          alt="Divine Support Care"
          className="rounded-lg shadow-2xl max-w-full h-auto max-h-[500px] object-cover"
        />
      </div>

      {/* Right Section - Content */}
      <div className="lg:w-1/2 lg:pl-12 text-center lg:text-left">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-800 mb-6">
          Divine Support Care
        </h1>
        <p className="text-lg sm:text-xl text-gray-600 leading-relaxed mb-8">
          At Divine, we believe in creating an inclusive world where every
          individual, regardless of their abilities, is celebrated for their
          unique strengths. Our mission is to empower and support people with
          disabilities, fostering a community that embraces diversity and
          promotes equal opportunities.
        </p>
        <button className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg shadow-lg transition duration-300 transform hover:scale-105">
          Learn More
        </button>
      </div>
    </div>
  );
};

export default HeroSection;